import React, { ReactElement, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { onChangeEmployeePosition } from '../../appRedux/actions';
import AuthContext, { IUserEP } from '../../contexts/AuthContext';
import IntlMessages from '../../util/IntlMessages';
export interface IUserRoleDataRenderArgs {
  setShowMenu?: (state: boolean) => void;
  toggleCollapsedSide?: () => void;
  showLogOut: boolean;
}
export default function UserRoleDataRender({
  setShowMenu,
  toggleCollapsedSide,
  showLogOut,
}: IUserRoleDataRenderArgs) {
  const dispatch = useDispatch();
  const authContext = useContext(AuthContext);

  const history = useHistory();
  const [positionOrganization, setPositionOrganization] = useState(
    new Map<IUserEP[], IUserEP[]>(),
  );

  useEffect(() => {
    setPositionOrganization(
      groupBy(authContext.userRoles, (x: IUserEP) => x.organizationId),
    );
  }, [authContext]);

  const groupBy = (list: IUserEP[], keyGetter: (item: IUserEP) => void) => {
    const map = new Map();
    list.forEach((item: IUserEP) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  };
  function changeHandler(item: IUserEP) {
    // userProfile
    if (authContext.setUserEmployeePosition) {
      // onChangeEmployeePosition
      authContext.setUserEmployeePosition(item);
      dispatch(onChangeEmployeePosition());
      if (toggleCollapsedSide) {
        toggleCollapsedSide();
      }
      if (setShowMenu) {
        setShowMenu(false);
      }
      return history.push('/team-work/instance?folder=Inbox-0');
    }
  }
  const DataRender = () => {
    const temp = [];
    for (const key of positionOrganization.keys()) {
      const data = positionOrganization.get(key);
      temp.push(
        <div className="gx-text-orange gx-mb-2">
          {data && data[0]?.organizationName}
        </div>,
      );
      const template = data?.map((item: IUserEP, index: number) => {
        return (
          <li
            className="gx-mb-2"
            onClick={() => changeHandler(item)}
            key={index}
          >
            <div
              className="gx-flex-row"
              style={{ justifyContent: 'space-between' }}
            >
              <span> {item.fullName}</span>

              <span className="gx-mr-3 gx-ml-3">
                {item.unreadCount && item.unreadCount > 0 ? (
                  <div className="gx-chat-date">
                    <div className="gx-bg-primary gx-rounded-circle gx-badge gx-text-white">
                      {item.unreadCount}
                    </div>
                  </div>
                ) : null}
              </span>
            </div>
          </li>
        );
      });
      temp.push(<ul>{template}</ul>);
    }
    return (
      <div>
        {temp.map((item: ReactElement, index: number) => {
          return <div key={index}>{item}</div>;
        })}
        {showLogOut && (
          <Link to="/auth/logout">
            <span className="gx-fs-sm">
              <IntlMessages id="topbar.Exit" />
            </span>
          </Link>
        )}
      </div>
    );
  };
  return DataRender();
}
